import { Component, OnInit, ViewChild, Input, ElementRef, AfterViewInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MatMenuTrigger } from '@angular/material';
import { MenuButton } from './tabmenu.model';

@Component({
    selector: 'app-tabmenu',
    templateUrl: './tabmenu.component.html',
    styleUrls: ['./tabmenu.component.scss']
})
export class TabMenuComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    @ViewChild('menuTriggerButton') menuTriggerButton: ElementRef;

    @Input() saveButton: MenuButton;
    @Input() buttons: MenuButton[];
    @Input() isAnyRowSelected: boolean = false;

    public enabled: boolean = false;
    
    constructor() {}

    ngOnInit() {
        window.addEventListener('scroll', this.onScroll, true);
    }

    ngAfterViewInit() {
        this.enabled = this.buttons && this.buttons != null && this.buttons.some(butt =>
            (butt.enabled && !butt.isForSelected) || (butt. enabled && butt.isForSelected && this.isAnyRowSelected));
        this.menuTriggerButton.nativeElement.disabled = !this.enabled;
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    }

    onScroll = (): void => {
        this.trigger.closeMenu();
        this.dropButtonFocus();
    }

    dropButtonFocus() {
        this.menuTriggerButton.nativeElement.blur();
    }

    public refreshMenuState() {
        this.enabled = this.buttons && this.buttons != null && this.buttons.some(butt =>
            (butt.enabled && !butt.isForSelected) || (butt.enabled && butt.isForSelected && this.isAnyRowSelected));
        this.menuTriggerButton.nativeElement.disabled = !this.enabled;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.refreshMenuState();
    }
}
